
export default {
    spacingDebug: true,
    components: {
        HeaderTemplate: () => import("~/components/global/templates/HeaderTemplate"),
        NewsCardTemplate: () => import("~/components/global/templates/NewsCardTemplate"),
        ButtonTemplate: () => import("~/components/global/templates/ButtonTemplate"),
    },
    props: {
        sectionId: {
            type: String,
            default: "news",
        },
        payload: {
            type: [Array, Object],
            default: () => [],
        },
    },
    computed: {
        items() {
            const items = this.payload?.body?.items;
            return Array.isArray(items) ? items.filter((item) => item?.slug && item?.title) : [];
        },
        heading() {
            const heading = this.payload?.heading || {};
            return {
                level: heading.level || "h2",
                textContent: heading.textContent || "",
                subtextContent: heading.subtextContent || "",
                alignment: heading.alignment || "center",
            };
        },
    },
};
